var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex", staticStyle: { gap: "1em" } }, [
    _c(
      "span",
      {
        staticClass:
          "border border-dark rounded-circle d-flex justify-content-center align-items-center",
        staticStyle: { width: "1.75em", height: "1.75em" },
      },
      [_vm._v("\n    " + _vm._s(_vm.index) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-column", staticStyle: { gap: "0.5em" } },
      [_c("span", [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }